import type { SVGProps } from 'react';
const SvgLogo = ({ width = 32, height = 32, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <circle cx={16} cy={16} r={16} fill="#234EEE" />
    <path
      fill="#FCFCFC"
      d="M15.831 5.333c5.985 0 10.837 4.776 10.837 10.667s-4.852 10.667-10.837 10.667v-8.548a7.39 7.39 0 0 1-7.082 5.273v-5.979a3.7 3.7 0 0 1-3.415 2.282v-7.39c1.54 0 2.86.942 3.415 2.28V8.609a7.39 7.39 0 0 1 7.082 5.272z"
    />
  </svg>
);
export default SvgLogo;
